// extracted by mini-css-extract-plugin
module.exports = {"formatted-date":"formatted-date-i9s8s","formattedDate":"formatted-date-i9s8s"};